module.exports = '4.12.2';



// WEBPACK FOOTER //
// ./src/version.js